"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePaintObject = exports.stringifyIPaintObject = exports.IPaintObject = void 0;
var utils_1 = require("../../../utils");
var default_label_1 = require("../../default-values/default-label");
var id_type_1 = require("../id-type");
var bit_matrix_1 = require("./bit-matrix");
exports.IPaintObject = (0, utils_1.IRecord)({
    type: 'paint',
    id: id_type_1.defaultId,
    label: default_label_1.defaultLabel,
    pixelTop: 0,
    pixelLeft: 0,
    bitMatrix: (0, bit_matrix_1.IBitMatrix)()
});
var stringifyIPaintObject = function (po) {
    return JSON.stringify({
        id: po.id,
        label: po.label,
        pixelTop: po.pixelTop,
        pixelLeft: po.pixelLeft,
        bitMatrix: (0, bit_matrix_1.stringifyIBitMatrix)(po.bitMatrix)
    });
};
exports.stringifyIPaintObject = stringifyIPaintObject;
var parsePaintObject = function (poStr) {
    var parsed = JSON.parse(poStr);
    return (0, exports.IPaintObject)({
        id: parsed.id,
        label: parsed.label,
        pixelTop: parsed.pixelTop,
        pixelLeft: parsed.pixelLeft,
        bitMatrix: (0, bit_matrix_1.parseBitMatrix)(parsed.bitMatrix)
    });
};
exports.parsePaintObject = parsePaintObject;
